var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85259 8.2231C7.80344 5.63041 11.7716 3.92115 13.7571 3.09532C19.426 0.737412 20.604 0.327819 21.3718 0.314149C21.5406 0.311319 21.9182 0.353168 22.1628 0.551624C22.3693 0.719195 22.4261 0.945561 22.4533 1.10444C22.4805 1.26331 22.5144 1.62524 22.4874 1.90803C22.1802 5.13584 20.851 12.9689 20.1747 16.5841C19.8886 18.1138 19.3251 18.6267 18.7797 18.6769C17.5942 18.786 16.6941 17.8935 15.5459 17.1408C13.7493 15.9631 12.7343 15.23 10.9904 14.0808C8.97499 12.7526 10.2815 12.0227 11.4301 10.8297C11.7307 10.5175 16.9537 5.76676 17.0548 5.3358C17.0674 5.2819 17.0792 5.08099 16.9598 4.9749C16.8404 4.86881 16.6643 4.90509 16.5372 4.93394C16.357 4.97484 13.4868 6.87188 7.92678 10.6251C7.1121 11.1845 6.37419 11.4571 5.71305 11.4428C4.9842 11.427 3.58217 11.0307 2.53991 10.6919C1.26154 10.2763 0.245511 10.0566 0.333984 9.3509C0.380066 8.98331 0.88627 8.60738 1.85259 8.2231Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.1a5ca364dacabdfe57def1391c21a3e2.svg";
export { ForwardRef as ReactComponent };